import { TutorialItem } from './types'

export const tutorialItems: TutorialItem[] = [
  {
    title: 'Create Revision - Step by step guide',
    description: `This document provides step-by-step instructions for creating a revision of a previous rating.
      `,
    documentUrl:
      'https://storage.googleapis.com/redmind-mapping.appspot.com/documentation/guides/guide_whs-create_revision.pdf',
  },
]
